import type { SVGProps } from 'react';

const SvgUserFanMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M3 21C3 17 5.5 11.5 12 11M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11ZM15.2 14C13.985 14 13 15.0043 13 16.2432C13 18.4864 15.6 20.5256 17 21C18.4 20.5256 21 18.4864 21 16.2432C21 15.0043 20.015 14 18.8 14C18.0559 14 17.3981 14.3766 17 14.9531C16.6019 14.3766 15.9441 14 15.2 14Z'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgUserFanMd;
